import { IconCircleCheck, IconUpvote, IconUpvoted, DeleteIcon } from 'component/icon';
import { component, demoFile } from 'system/demo';
import { HorizBox, Pad } from 'component/basics';


demoFile('component/icon');

function IconsDemo() {
    return <HorizBox center>
        <IconCircleCheck />
        <Pad size={8} />
        <IconUpvote />
        <Pad size={8} />
        <IconUpvoted />
        <Pad size={8} />
        <DeleteIcon />
    </HorizBox>;
}

component('Icons', IconsDemo);
